export default function HeroSection() {
  return (
    <section className="relative w-full h-[550px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20soft%20minimalist%20nursery%20interior%20with%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20cream%20and%20beige%20color%20palette%2C%20wooden%20crib%20with%20soft%20blankets%2C%20peaceful%20motherhood%20atmosphere%2C%20elegant%20pastel%20tones&width=1920&height=900&seq=hero-mia-2025&orientation=landscape"
        alt="蜜芽母婴 - 全球精选好物"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <div className="max-w-3xl">
          <p className="text-background-50/90 text-sm md:text-base tracking-widest mb-4 animate-fadeIn">
            蜜芽 · 母婴跨境电商平台
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight animate-slideUp" style={{ fontFamily: "var(--font-heading)" }}>
            全球母婴精选
            <br />
            <span className="text-accent-300">好物一站购齐</span>
          </h1>
          <p className="text-background-50/80 text-sm md:text-lg max-w-xl mx-auto mb-8 animate-slideUp" style={{ animationDelay: '0.1s' }}>
            汇聚全球3000+优质母婴品牌，正品保障，高性价比
            <br className="hidden md:block" />
            让每位妈妈轻松选购全球好货，守护宝宝健康成长
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-slideUp" style={{ animationDelay: '0.2s' }}>
            <a
              href="/category/milk-powder"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              立即选购
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="/about"
              className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              了解蜜芽
              <i className="ri-information-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}